// I campi quantità del Quaderno di Campagna sono testo libero (non
// type="number"), e un utente italiano digita naturalmente la virgola come
// separatore decimale (es. "1,5"). isNaN/parseFloat nativi però capiscono
// solo il punto: "1,5" viene interpretato come non numerico da isNaN() e
// troncato a "1" da parseFloat(), causando sia falsi errori di validazione
// sia calcoli silenziosamente sbagliati. Questo helper normalizza prima di
// interpretare il valore come numero.
export function parseNumeroItaliano(valore) {
  if (valore === null || valore === undefined) {
    return NaN;
  }
  return parseFloat(String(valore).trim().replace(",", "."));
}

export function isNumeroValido(valore) {
  return valore !== "" && valore !== null && !isNaN(parseNumeroItaliano(valore));
}
